import React from 'react';
import { Link } from '@tanstack/react-router';

/**
 * Utility function to close the navigation drawer
 * Uses a type guard to safely access the checked property
 */
const closeNavDrawer = (): void => {
  const element = document.getElementById('nav-drawer');

  // Type guard to check if element is an HTMLInputElement
  const isHTMLInputElement = (el: Element | null): el is HTMLInputElement => {
    return el !== null && el instanceof HTMLInputElement;
  };

  // Use type guard to safely access checked property
  if (isHTMLInputElement(element)) {
    element.checked = false;
  }
};

export const Sidebar: React.FC = () => {
  return (
    <div className="drawer-side z-10">
      <label htmlFor="nav-drawer" aria-label="close sidebar" className="drawer-overlay"></label>
      <div className="bg-base-200 min-h-full w-80">
        {/* App title with logo */}
        <div className="p-5 bg-base-300 flex items-center">
          <img src="/icons/logo.svg" alt="FretGenius Logo" className="h-10 w-auto mr-3" />
          <h2 className="text-2xl font-bold">FretGenius</h2>
        </div>

        {/* Navigation menu */}
        <ul className="menu p-5 text-base-content">
          <li className="menu-title">
            <span className="text-lg">Navigation</span>
          </li>
          <li className="font-medium">
            <Link
              to="/"
              activeProps={{ className: 'menu-active' }}
              onClick={closeNavDrawer}
              preload="intent"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
              </svg>
              <span className="text-lg">Home</span>
            </Link>
          </li>
          <li className="menu-title">
            <span className="text-lg">Learning</span>
          </li>
          <li>
            <Link
              to="/scale-display"
              activeProps={{ className: 'menu-active' }}
              onClick={closeNavDrawer}
              preload="intent"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 001.414 1.414L9 9.414V13a1 1 0 102 0V9.414l1.293 1.293a1 1 0 001.414-1.414z"
                  clipRule="evenodd"
                />
              </svg>
              <span className="text-lg">Scales</span>
            </Link>
          </li>
          <li>
            <Link
              to="/note-quiz"
              activeProps={{ className: 'menu-active' }}
              onClick={closeNavDrawer}
              preload="intent"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path d="M9 4.804A7.968 7.968 0 005.5 4c-1.255 0-2.443.29-3.5.804v10A7.969 7.969 0 015.5 14c1.669 0 3.218.51 4.5 1.385A7.962 7.962 0 0114.5 14c1.255 0 2.443.29 3.5.804v-10A7.968 7.968 0 0014.5 4c-1.255 0-2.443.29-3.5.804V12a1 1 0 11-2 0V4.804z" />
              </svg>
              <span className="text-lg">Note Quiz</span>
            </Link>
          </li>

          <li className="menu-title mt-4">
            <span className="text-lg">Help</span>
          </li>
          <li>
            <Link
              to="/feedback"
              activeProps={{ className: 'menu-active' }}
              onClick={closeNavDrawer}
              preload="intent"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z"
                  clipRule="evenodd"
                />
              </svg>
              <span className="text-lg">Send Suggestion</span>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};
